import { useState } from "react";
import ReactPlayer from "react-player"

export default function VideoPlayer({
    src,
    giflike = true,
    videoLeft = true,
    videoCentered = false,
    scale = 1.2,
    children,
    hoverToPause = false
}) {
    const [hover, setHover] = useState(false);
    const [enlarge, setEnlarge] = useState(false);

    const wrapperStyle = {
        display: "flex",
        flexDirection: videoCentered ? "column" : (videoLeft ? "row" : "row-reverse"),
        gap: videoCentered ? 0 : 32,
        alignItems: "center",
        // flexGrow: 1,
    }



    const textStyleVideoCentered = {
        display: "flex", flexDirection: "column",
        alignItems: "center",
        width: scale * 480,
    }

    const textStyle = {
        flexGrow: 1,
        ...(videoCentered ? textStyleVideoCentered : null)
    }


    return <div style={wrapperStyle}>
        <div
            onClick={() => setEnlarge(true)}
            onMouseOver={() => setHover(true)}
            onMouseOut={() => { setHover(false); setEnlarge(false) }}
            style={{
                transition: "transform 0.1s ease-in-out",
                transform: enlarge ? "scale(2)" : "scale(1)",
                zIndex: enlarge ? 9999 : 0,
                display: "flex", flexDirection: "column", alignItems: "center",
                cursor: enlarge ? "" : "zoom-in"
            }}
        >
            <ReactPlayer
                src={src}
                playing={giflike && (hoverToPause == false || hover == false)}
                loop={giflike}
                controls={giflike == false}
                muted={true}
                width={scale * 320}
                height={scale * 180}

                // height={"auto"}
                style={{
                    backdropFilter: "blur(4px)", boxShadow: "0px 0px 4px #00000090", aspectRatio: "16/9",

                }}
            />
            {(hover && enlarge == false) && <div style={{
                position: "absolute",
                bottom: 2,
                fontSize: "12px",
                textShadow: "0px 0px 4px black"
            }}>
                click to enlarge
            </div>}
        </div>
        <p style={textStyle}>
            {children}
        </p>
    </div>;
}

export function VideoPlayerWithText() {
    return <div>
        <VideoPlayer />
    </div>
}

